import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

// Card permanente en el dashboard que da acceso al módulo Mi Ciclo Hormonal.
// Sigue visible aunque el usuario haya omitido el banner.
export default function HormonalCycleCard() {
  const navigate = useNavigate();
  return (
    <div
      className="rounded-2xl p-5 transition-all hover:scale-[1.01] cursor-pointer"
      style={{
        background: 'linear-gradient(135deg, rgba(var(--brand-primary-glow), 0.08), rgba(192, 132, 252, 0.04))',
        border: '1px solid rgba(192, 132, 252, 0.2)'
      }}
      onClick={() => navigate('/mi-ciclo-hormonal')}
      data-testid="hormonal-cycle-card"
    >
      <div className="flex items-center gap-4">
        <div className="text-4xl">🌙</div>
        <div className="flex-1">
          <h4 className="text-white font-bold text-base">Mi ciclo hormonal</h4>
          <p className="text-gray-400 text-xs">Sugerencias según tu ciclo, energía y síntomas.</p>
        </div>
        <Button size="sm" className="text-white text-xs" style={{ background: 'linear-gradient(135deg, var(--brand-primary), #C084FC)' }} data-testid="enter-cycle-card-btn">
          Entrar
        </Button>
      </div>
    </div>
  );
}
